const scale = 0.8;
const fontScale = 0.9;
const calcFont = (unit) => unit * fontScale;
const calc = (unit) => Math.round(unit * scale);

const K = {
  insets: (insets, sideKey, standardValue) => insets[sideKey] + (standardValue || 0),
  calc,
  calcFont,
  spacing: 15,
  margin: 5,
  borderRadius: 1.5,
  borderWidth: 1,
  paddingHorizontal: 15,
  paddingVertical: 10,
  inputHeight: 30,
  verticalInputPadding: 15,
  standardColumnWidth: 400,
  headerHeight: scale * 30 + 30,
  colors: {
    accent: '#000000',
    active: '#0075FF',
    activeBlackGray: '#666',
    base: '#ffffff',
    blackGray: '#333',
    darkBlue: '#000060',
    darkGray: '#D9D9D9',
    deleteRed: '#F89A90',
    doubleGray: '#e7e7e7',
    gray: '#F5F5F5',
    grayOverlay: '#d9d9d960',
    grayLabel: '#848484',
    grayBorder: 'rgba(0, 0, 0, 0.03)',
    inactive: '#CCCCCC',
    invalid: '#F57293',
    overlay: 'rgba(0, 0, 0, 0.5)',
    purchaseBlue: '#98a0b8',
  },
  fonts: {
    standard: {fontSize: 14, letterSpacing: 0.4},
    label: {fontSize: 13, letterSpacing: 0.8, textTransform: 'uppercase', opacity: 0.6, lineHeight: 13 * 1.4},
    su: {fontSize: 13, letterSpacing: 0.8, textTransform: 'uppercase'},
    pageHeader: {fontSize: 18, letterSpacing: 1, fontWeight: 'bold'},
    projectTitle: {fontSize: 18, letterSpacing: 1.5, lineHeight: 1.5, fontWeight: 'bold'}
  },
  explanationText: {
    marginTop: scale * 15,
    padding: scale * 15,
    fontStyle: 'italic'
  },
  shadow: {boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.2)'},
  disabled: {
    cursor: 'not-allowed',
  },
  defaultIconSize: {width: 20, height: 20},
  defaultIconStyle: {style: {width: 20, height: 20}},
  preventSelection: {
    userSelect: 'none',
    WebkitUserSelect: 'none',
    WebkitTouchCallout: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
  },
  placements: {
    TOP: 'top',
    LEFT: 'left',
    BOTTOM: 'bottom',
    RIGHT: 'right',
    CENTER: 'center',
  },
};

export default K;